import { setupInterceptorsTo } from "./Interceptors";
import axios from "axios";

const http = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL || 'https://api.watchfaces.club/api/',
});

export default http;

setupInterceptorsTo(http);